import * as ActionTypes from '../ActionTypes'
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';

// Subcontractors of Client
export const ClientSubcontractorsReducer = (state = { 
                status: ReduxDataStatus.IDLE,
                loadTime: null,
                loadCriteria: {},
                errMess: null,
                clientSubcontractors:[]
            }, action) => {
                
    switch (action.type) {
        case ActionTypes.CLIENT_SUBCONS_LOADING:
            return {...state, status: ReduxDataStatus.LOADING, errMess: null, clientSubcontractors: [], loadTime: Date.now(), loadCriteria: action.payload}

        case ActionTypes.ADD_CLIENT_SUBCONS:
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, clientSubcontractors: action.payload};

        case ActionTypes.CLIENT_SUBCONS_FAILED:
            return {...state, status: ReduxDataStatus.FAILED, errMess: action.payload, loadTime: null, loadCriteria: {}};

        case ActionTypes.ADD_CLIENT_SUBCON:
            const nSubcon = action.payload;
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, clientSubcontractors: state.clientSubcontractors.concat(nSubcon)};
    
        case ActionTypes.UPDATE_CLIENT_SUBCON:
            const uSubcon = action.payload;
            const updatedClientSubcons = state.clientSubcontractors.map(e => e.id === uSubcon.id ? uSubcon : e );
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, clientSubcontractors: updatedClientSubcons};

        default:
            return state;
    }
};